<template>
  <div class="home-container">
    <!-- 统计卡片 -->
    <el-row :gutter="20" class="stats-row">
      <el-col :span="6">
        <el-card class="stats-card">
          <div class="stats-content">
            <div class="stats-icon user-icon">
              <i class="el-icon-user-solid"></i>
            </div>
            <div class="stats-info">
              <div class="stats-number">1,234</div>
              <div class="stats-label">用户总数</div>
            </div>
          </div>
        </el-card>
      </el-col>
      
      <el-col :span="6">
        <el-card class="stats-card">
          <div class="stats-content">
            <div class="stats-icon order-icon">
              <i class="el-icon-s-order"></i>
            </div>
            <div class="stats-info">
              <div class="stats-number">5,678</div>
              <div class="stats-label">订单总数</div>
            </div>
          </div>
        </el-card>
      </el-col>
      
      <el-col :span="6">
        <el-card class="stats-card">
          <div class="stats-content">
            <div class="stats-icon revenue-icon">
              <i class="el-icon-money"></i>
            </div>
            <div class="stats-info">
              <div class="stats-number">¥89,012</div>
              <div class="stats-label">总收入</div>
            </div>
          </div>
        </el-card>
      </el-col>
      
      <el-col :span="6">
        <el-card class="stats-card">
          <div class="stats-content">
            <div class="stats-icon growth-icon">
              <i class="el-icon-data-line"></i>
            </div>
            <div class="stats-info">
              <div class="stats-number">23.5%</div>
              <div class="stats-label">增长率</div>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <!-- 图表区域 -->
    <el-row :gutter="20" class="chart-row">
      <el-col :span="12">
        <el-card class="chart-card">
          <div slot="header" class="chart-header">
            <span>用户增长趋势</span>
            <el-button-group class="chart-buttons">
              <el-button size="mini" :type="timeRange === 'week' ? 'primary' : ''" @click="changeTimeRange('week')">周</el-button>
              <el-button size="mini" :type="timeRange === 'month' ? 'primary' : ''" @click="changeTimeRange('month')">月</el-button>
              <el-button size="mini" :type="timeRange === 'year' ? 'primary' : ''" @click="changeTimeRange('year')">年</el-button>
            </el-button-group>
          </div>
          <div class="chart-container" ref="userChart"></div>
        </el-card>
      </el-col>
      
      <el-col :span="12">
        <el-card class="chart-card">
          <div slot="header" class="chart-header">
            <span>销售统计</span>
            <el-button-group class="chart-buttons">
              <el-button size="mini" :type="chartType === 'bar' ? 'primary' : ''" @click="changeChartType('bar')">柱状图</el-button>
              <el-button size="mini" :type="chartType === 'line' ? 'primary' : ''" @click="changeChartType('line')">折线图</el-button>
            </el-button-group>
          </div>
          <div class="chart-container" ref="salesChart"></div>
        </el-card>
      </el-col>
    </el-row>

    <!-- 数据表格 -->
    <el-row class="table-row">
      <el-col :span="24">
        <el-card class="table-card">
          <div slot="header" class="table-header">
            <span>最新订单</span>
            <el-button type="text" @click="viewMore">查看更多</el-button>
          </div>
          <el-table :data="orderData" style="width: 100%">
            <el-table-column prop="id" label="订单号" width="120"></el-table-column>
            <el-table-column prop="customer" label="客户名称" width="150"></el-table-column>
            <el-table-column prop="product" label="产品名称"></el-table-column>
            <el-table-column prop="amount" label="金额" width="120">
              <template slot-scope="scope">
                <span class="amount">¥{{ scope.row.amount }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="status" label="状态" width="100">
              <template slot-scope="scope">
                <el-tag :type="getStatusType(scope.row.status)">
                  {{ scope.row.status }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="createTime" label="创建时间" width="180"></el-table-column>
            <el-table-column label="操作" width="150">
              <template slot-scope="scope">
                <el-button type="text" size="small" @click="viewOrder(scope.row)">查看</el-button>
                <el-button type="text" size="small" @click="editOrder(scope.row)">编辑</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'Home',
  data() {
    return {
      timeRange: 'month',
      chartType: 'bar',
      userChart: null,
      salesChart: null,
      orderData: [
        {
          id: 'ORD001',
          customer: '张三',
          product: '产品A',
          amount: '1,200.00',
          status: '已完成',
          createTime: '2024-12-01 10:30:00'
        },
        {
          id: 'ORD002',
          customer: '李四',
          product: '产品B',
          amount: '800.00',
          status: '处理中',
          createTime: '2024-12-01 09:15:00'
        },
        {
          id: 'ORD003',
          customer: '王五',
          product: '产品C',
          amount: '2,500.00',
          status: '已完成',
          createTime: '2024-11-30 16:45:00'
        },
        {
          id: 'ORD004',
          customer: '赵六',
          product: '产品D',
          amount: '600.00',
          status: '待处理',
          createTime: '2024-11-30 14:20:00'
        }
      ]
    }
  },
  mounted() {
    this.initCharts()
  },
  beforeDestroy() {
    // 销毁图表实例
    if (this.userChart) {
      this.userChart.dispose()
    }
    if (this.salesChart) {
      this.salesChart.dispose()
    }
  },
  methods: {
    initCharts() {
      // 初始化用户增长趋势图
      this.initUserChart()
      // 初始化销售统计图
      this.initSalesChart()
    },
    
    initUserChart() {
      // 这里使用简单的DOM操作模拟图表
      // 实际项目中应该使用ECharts等图表库
      const chartContainer = this.$refs.userChart
      chartContainer.innerHTML = `
        <div style="height: 100%; display: flex; align-items: center; justify-content: center; background: #f9f9f9; border-radius: 4px;">
          <div style="text-align: center;">
            <i class="el-icon-data-line" style="font-size: 48px; color: #409EFF; margin-bottom: 10px;"></i>
            <div style="color: #666;">用户增长趋势图表</div>
            <div style="color: #999; font-size: 12px; margin-top: 5px;">时间范围: ${this.timeRange === 'week' ? '周' : this.timeRange === 'month' ? '月' : '年'}</div>
          </div>
        </div>
      `
    },
    
    initSalesChart() {
      // 这里使用简单的DOM操作模拟图表
      const chartContainer = this.$refs.salesChart
      chartContainer.innerHTML = `
        <div style="height: 100%; display: flex; align-items: center; justify-content: center; background: #f9f9f9; border-radius: 4px;">
          <div style="text-align: center;">
            <i class="el-icon-s-data" style="font-size: 48px; color: #67C23A; margin-bottom: 10px;"></i>
            <div style="color: #666;">销售统计图表</div>
            <div style="color: #999; font-size: 12px; margin-top: 5px;">图表类型: ${this.chartType === 'bar' ? '柱状图' : '折线图'}</div>
          </div>
        </div>
      `
    },
    
    changeTimeRange(range) {
      this.timeRange = range
      this.initUserChart()
    },
    
    changeChartType(type) {
      this.chartType = type
      this.initSalesChart()
    },
    
    getStatusType(status) {
      const statusMap = {
        '已完成': 'success',
        '处理中': 'warning',
        '待处理': 'info',
        '已取消': 'danger'
      }
      return statusMap[status] || 'info'
    },
    
    viewOrder(order) {
      this.$message.info(`查看订单: ${order.id}`)
    },
    
    editOrder(order) {
      this.$message.info(`编辑订单: ${order.id}`)
    },
    
    viewMore() {
      this.$message.info('查看更多订单')
    }
  }
}
</script>

<style scoped>
.home-container {
  max-width: 1200px;
  margin: 0 auto;
}

/* 统计卡片样式 */
.stats-row {
  margin-bottom: 20px;
}

.stats-card {
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}

.stats-content {
  display: flex;
  align-items: center;
  padding: 10px 0;
}

.stats-icon {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 15px;
}

.stats-icon i {
  font-size: 24px;
  color: #fff;
}

.user-icon {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.order-icon {
  background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
}

.revenue-icon {
  background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
}

.growth-icon {
  background: linear-gradient(135deg, #43e97b 0%, #38f9d7 100%);
}

.stats-info {
  flex: 1;
}

.stats-number {
  font-size: 24px;
  font-weight: 600;
  color: #333;
  margin-bottom: 5px;
}

.stats-label {
  font-size: 14px;
  color: #666;
}

/* 图表样式 */
.chart-row {
  margin-bottom: 20px;
}

.chart-card {
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}

.chart-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: 600;
}

.chart-container {
  height: 300px;
}

/* 表格样式 */
.table-card {
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}

.table-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: 600;
}

.amount {
  font-weight: 600;
  color: #67C23A;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .stats-row .el-col {
    margin-bottom: 15px;
  }
  
  .chart-row .el-col {
    margin-bottom: 15px;
  }
  
  .stats-content {
    flex-direction: column;
    text-align: center;
  }
  
  .stats-icon {
    margin-right: 0;
    margin-bottom: 10px;
  }
}
</style>